import moment from 'moment';
import {
    OAUTH_REFRESH_COOKIE_EXPIRES_SEC,
    LOCALE_COOKIE_EXPIRES_SEC,
    THEME_COOKIE_EXPIRES_SEC,
    GDPR_COOKIE_EXPIRES_SEC,
    GENERAL_COOKIE_EXPIRES_SEC
} from '@constants/index';

function createExpirationDate(timeInSeconds) {
    return new Date(moment().add(timeInSeconds, 'seconds').toDate());
}

export function getOAuthRefreshCookieExpiration() {
    return createExpirationDate(OAUTH_REFRESH_COOKIE_EXPIRES_SEC);
}

export function getLocaleCookieExpiration() {
    return createExpirationDate(LOCALE_COOKIE_EXPIRES_SEC);
}

export function getThemeCookieExpiration() {
    return createExpirationDate(THEME_COOKIE_EXPIRES_SEC);
}

export function getGDPRCookieExpiration() {
    return createExpirationDate(GDPR_COOKIE_EXPIRES_SEC);
}

export function getGeneralCookieExpiration() {
    return createExpirationDate(GENERAL_COOKIE_EXPIRES_SEC);
}